import { connect } from "react-redux"

import CommunityEditRelated from "./CommunityEditRelated"

import {
    autocompleteCommunitiesRequest,
    autocompleteDimensionsRequest,
    autocompleteProjectsRequest,
    autocompleteTopicsRequest
} from "../../../../actions/autocomplete-actions"

const mapStateToProps = ({ presentation: { communities } }) => ({
    topics: communities.workingModel.topics,
    dimensions: communities.workingModel.dimensions,
    projects: communities.workingModel.projects,
    communities: communities.workingModel.communities
})

const mapDispatchToProps = (dispatch, { onEventChange, onValueChange }) => ({
    onTopicsSearch: (searchTerm, callback) => {
        dispatch(autocompleteTopicsRequest(searchTerm, callback))
    },
    onDimensionsSearch: (searchTerm, callback) => {
        dispatch(autocompleteDimensionsRequest(searchTerm, callback))
    },
    onProjectsSearch: (searchTerm, callback) => {
        dispatch(autocompleteProjectsRequest(searchTerm, callback))
    },
    onCommunitiesSearch: (searchTerm, callback) => {
        dispatch(autocompleteCommunitiesRequest(searchTerm, callback))
    },
    onEventChange,
    onValueChange
})

export default connect(mapStateToProps, mapDispatchToProps)(
    CommunityEditRelated
)
